import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import ActivityPatchBase from './AvailabilityPatchBase';
import Header from '../header';
import Card, { CardTitle } from '../Card';
import AvailabilityTableView from './ActivityTableView';
import { useSearchParams } from 'react-router-dom';

const ActivityPatch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionParam = searchParams.get('action');
  const viewParam = searchParams.get('view');
  const modeParam = searchParams.get('mode');
  const showBackButton = actionParam === 'failedupdates';

  // Initialize view from query param, default to 'table' (false)
  const [view, setView] = useState(viewParam === 'card');
  const [mode, setMode] = useState(modeParam === 'Automated' ? 'Automated' : 'OnDemand');

  // Update query params when view or mode changes
  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('view', view ? 'card' : 'table');
    newParams.set('mode', mode);
    setSearchParams(newParams, { replace: true });
  }, [view, mode]);

  const viewFunction = () => {
    setView((prev) => !prev);
  };

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className=" flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Activities" dropdown={2} showBackButton={showBackButton} />

        <Card className="flex-1 h-full" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          {view && <ActivityPatchBase viewFunction={viewFunction} mode={mode} setMode={setMode} />}

          {!view && <AvailabilityTableView viewFunction={viewFunction} mode={mode} setMode={setMode} />}
        </Card>
      </div>
    </div>
  );
};

export default ActivityPatch;
